import React from "react";
import RobustAssessment from "@/pages/RobustAssessment";
import ParticipantIdentityGate from "@/components/assessment/ParticipantIdentityGate";

const AssessmentEntry = () => (
  <ParticipantIdentityGate>
    <RobustAssessment />
  </ParticipantIdentityGate>
);

export default AssessmentEntry;
